import { SiteWebAppData, ContractData, ContractContactData, CustomerData, ConfigurationData } from 'app/core/hub-api';

export class AddEditContractContactModalContext {
  editMode: boolean;
  chooseContractMode: boolean;
  site: SiteWebAppData;
  contract?: ContractData;
  contractContact?: ContractContactData;
  customers: CustomerData[];
  configuration: ConfigurationData;
}
